export default __webpack_public_path__ + "static/media/placeholder-image-01.f1cf0089.jpg";